import React from 'react';
import { Button } from './button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './dialog';
import { toast } from 'sonner';
import { Copy, Check } from 'lucide-react';

const ShareTextDialog = ({ open, onOpenChange, title, text }) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success('Texto copiado al portapapeles');
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      toast.error('Error al copiar');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            Copia este texto y pégalo en WhatsApp (cualquier contacto o grupo)
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg max-h-96 overflow-y-auto">
            <pre className="whitespace-pre-wrap text-sm font-mono">
              {text}
            </pre>
          </div>

          <div className="flex gap-2">
            <Button
              onClick={handleCopy}
              className="flex-1"
              data-testid="copy-button"
            >
              {copied ? (
                <>
                  <Check className="mr-2" size={18} />
                  ¡Copiado!
                </>
              ) : (
                <>
                  <Copy className="mr-2" size={18} />
                  Copiar Texto
                </>
              )}
            </Button>
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
              data-testid="close-button"
            >
              Cerrar
            </Button>
          </div>

          <p className="text-sm text-gray-500 text-center">
            Después de copiar, abre WhatsApp, selecciona el contacto o grupo y pega el texto
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareTextDialog;
